import * as React from 'react'

import { cn } from '@/lib/utils'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

const OptionsPanel: React.FC<IProps> = ({ className, children, ...rest }) => {
  return (
    <div
      data-slot="options-panel"
      className={cn('tw:flex tw:flex-col tw:min-h-0 tw:gap-2.5', className)}
      {...rest}
    >
      {children}
    </div>
  )
}

export default OptionsPanel
